import SimpleCrud from "./SimpleCrud";

const EMPTY = { truck_number: "", make: "", model: "", year: 0, vin: "", status: "available", notes: "" };
const FIELDS = [
  { key: "truck_number", label: "Truck #" },
  { key: "make", label: "Make" },
  { key: "model", label: "Model" },
  { key: "year", label: "Year", type: "number" },
  { key: "vin", label: "VIN" },
  { key: "status", label: "Status" },
  { key: "notes", label: "Notes", textarea: true },
];

export default function Trucks() {
  return <SimpleCrud title="Trucks" endpoint="trucks" testid="trucks-admin" empty={EMPTY} fields={FIELDS} />;
}
